import { lazy, Suspense } from "react";
import { createBrowserRouter } from "react-router-dom";
import AppLayout from "./AppLayout";
import MainHome from "./pages/MainHome";
import Login from "./pages/Login";
import SignUp from "./pages/Signup";
import Userprotectedroutes from "./components/ProtectedRoute/Userprotectedroutes"; 

const Fullmarket = lazy(() => import("./pages/Fullmarket/Fullmarket"));

// Route configuration
export const DiamondExchnageRoutes = createBrowserRouter([
  {
    path: "/",
    element: (
      <Userprotectedroutes>
        <AppLayout />
      </Userprotectedroutes>
    ),
    children: [
      {
        index: true,
        element: <MainHome />,
      },
    ],
  },

  {
    path: "/fullmarket",
    element: (
      <Userprotectedroutes>
        <Suspense fallback={<div>Loading...</div>}>
          <Fullmarket />
        </Suspense>
      </Userprotectedroutes>
    ),
  },

  // Public Routes
  {
    path: "/login",
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <Login />
      </Suspense>
    ),
  },
  {
    path: "/signup",
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <SignUp />
      </Suspense>
    ),
  },
]);
